import React from "react";

interface TimelineBookingProps {
  data: {
    service: any; // Dynamic type accepting API TimelineBooking response
    totalBookings?: number;
  };
  handlers: {
    onClick: (service: any) => void;
  };
}

// Map possible backend statuses to Tailwind border & background classes
const statusStyles: Record<string, { border: string; bg: string; text: string }> = {
  Pending: {
    border: "border-amber-300",
    bg: "bg-amber-50",
    text: "text-amber-800",
  },
  Confirmed: {
    border: "border-blue-300",
    bg: "bg-blue-50",
    text: "text-blue-800",
  },
  InProgress: {
    border: "border-purple-300",
    bg: "bg-purple-50",
    text: "text-purple-800",
  },
  Completed: {
    border: "border-emerald-300",
    bg: "bg-emerald-50",
    text: "text-emerald-800",
  },
  Cancelled: {
    border: "border-rose-300",
    bg: "bg-rose-50",
    text: "text-rose-800",
  },
  Rescheduled: {
    border: "border-indigo-300",
    bg: "bg-indigo-50",
    text: "text-indigo-800",
  },
};

// Fallback style if status key is missing or undefined
const defaultStyle = {
  border: "border-slate-200",
  bg: "bg-slate-50",
  text: "text-slate-700",
};

const TimelineBooking: React.FC<TimelineBookingProps> = ({ data, handlers }) => {
  const { service } = data;

  // Safe status lookup with fallback to defaultStyle
  const statusKey = service?.status || service?.paymentStatus || "Pending";
  const currentStyle = statusStyles[statusKey] || defaultStyle;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handlers.onClick(service);
      }}
      className={`
        rounded-lg
        border
        ${currentStyle.border}
        ${currentStyle.bg}
        p-2
        text-xs
        shadow-xs
        cursor-pointer
        transition-all
        duration-150
        hover:shadow-md
      `}
    >
      <div className={`font-semibold ${currentStyle.text} truncate`}>
        {service?.customerName || "Customer"}
      </div>

      <div className="text-slate-500 text-[11px] truncate mt-0.5">
        {service?.packageName || service?.serviceName || "Package"}
      </div>

      <div className="text-slate-400 text-[10px] mt-1">
        {service?.startTime ? `${service.startTime} - ${service.endTime}` : service?.serviceTime}
      </div>
    </div>
  );
};

export default TimelineBooking;